import React, { useState } from 'react';
import { Field, Text, Checkbox, RadioGroup, SectionShell } from './FormControls';
import ValveSettingsModal from '../vid/ValveSettingsModal';

const MISSING_PLACEHOLDER = 'Unable to obtain — please enter';

const TankDetailsSection = ({
  data,
  update,
  onSerialLookup,
  serialLookupState = { loading: false, notFound: false },
  missingVesselFields = {},
  onOpenLineOfContact,
}) => {
  const [valveModalOpen, setValveModalOpen] = useState(false);
  const typeCodeDigits = String(data.typeCode || '').replace(/\D/g, '');

  return (
    <>
  <SectionShell title="Tank Details" description="Tank plate data and usage configuration">
    <Field
      label="Tank Serial Number"
      required
      hint={
        serialLookupState.loading
          ? 'Looking up vessel…'
          : serialLookupState.notFound
            ? 'Serial number not found in Vessel Inventory.'
            : serialLookupState.scrapped
              ? 'This vessel has been scrapped. A certificate cannot be issued against it.'
              : serialLookupState.usingCalorSerial
                ? `Showing Calor serial number — inventory serial ${serialLookupState.matchedSerial || ''}.`
                : 'Enter the standard serial number or the Calor serial number.'
      }
    >
      <input
        type="text"
        value={data.serialNumber || ''}
        onChange={(e) => update('serialNumber', e.target.value)}
        onBlur={() => onSerialLookup && onSerialLookup()}
        required
        className="pvs-input w-full"
      />
    </Field>
    <Field label="Nameplate / Test Code" required>
      <Text value={data.nameplateTestCode} onChange={(v) => update('nameplateTestCode', v)} required />
    </Field>
    <div>
      <span className="block text-sm font-medium text-pvs-text-muted mb-2">
        Type Code<span className="text-red-400"> *</span>
      </span>
      <div className="flex gap-2">
        <div className="flex-1">
          <Text value={data.typeCode} onChange={(v) => update('typeCode', v)} required />
        </div>
        <button
          type="button"
          onClick={() => setValveModalOpen(true)}
          disabled={!typeCodeDigits}
          className="px-3 py-2 rounded-lg bg-pvs-accent text-pvs-bg font-semibold text-sm whitespace-nowrap hover:bg-pvs-accent-dim disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Valve settings
        </button>
      </div>
      <span className="block text-xs text-pvs-text-dim mt-1">
        Enter the three-digit VID type code, then open Valve settings for the valves and torques for that code.
      </span>
    </div>
    <Field label="Manufacturer's Code" required>
      <Text value={data.manufacturersCode} onChange={(v) => update('manufacturersCode', v)} required />
    </Field>
    <Field label="Manufacturer Name" required>
      <Text
        value={data.manufacturerName}
        onChange={(v) => update('manufacturerName', v)}
        placeholder={missingVesselFields.manufacturerName ? MISSING_PLACEHOLDER : ''}
        required
      />
    </Field>
    <Field label="Manufacturer's Test Date" required>
      <Text
        value={data.manufacturersTestDate}
        onChange={(v) => update('manufacturersTestDate', v)}
        placeholder={missingVesselFields.manufacturersTestDate ? MISSING_PLACEHOLDER : 'e.g. 2020-05'}
        required
      />
    </Field>
    <Field label="Previous In-Service Date Code" required>
      <Text value={data.previousInserviceDateCode} onChange={(v) => update('previousInserviceDateCode', v)} required />
    </Field>
    <Field label="Previous Thorough Date Code" required>
      <Text value={data.previousThoroughDateCode} onChange={(v) => update('previousThoroughDateCode', v)} required />
    </Field>
    <Field label="Tank Size" required>
      <Text
        value={data.tankSize}
        onChange={(v) => update('tankSize', v)}
        placeholder={missingVesselFields.tankSize ? MISSING_PLACEHOLDER : ''}
        required
      />
    </Field>
    <Field label="Design Code" required>
      <Text value={data.designCode} onChange={(v) => update('designCode', v)} required />
    </Field>
    <Field label="Design Pressure" required>
      <Text
        value={data.designPressure}
        onChange={(v) => update('designPressure', v)}
        placeholder={missingVesselFields.designPressure ? MISSING_PLACEHOLDER : ''}
        required
      />
    </Field>
    <Field label="Colour" required>
      <RadioGroup
        name="tankColour"
        value={data.colour}
        onChange={(v) => update('colour', v)}
        options={[
          { value: 'green', label: 'Green' },
          { value: 'white', label: 'White' },
        ]}
      />
    </Field>
    <div className="flex flex-col gap-2 mt-2">
      <span className="text-sm font-medium text-pvs-text-muted">Use<span className="text-red-400"> *</span></span>
      <Checkbox label="Vapour" checked={data.useVap} onChange={(v) => update('useVap', v)} />
      <Checkbox label="Top Liquid" checked={data.useTopLiq} onChange={(v) => update('useTopLiq', v)} />
      <Checkbox label="Bottom Liquid" checked={data.useBottomLiq} onChange={(v) => update('useBottomLiq', v)} />
    </div>
  </SectionShell>
      {valveModalOpen ? (
        <ValveSettingsModal
          typeCode={data.typeCode}
          onClose={() => setValveModalOpen(false)}
          onOpenLineOfContact={onOpenLineOfContact}
        />
      ) : null}
    </>
  );
};

export default TankDetailsSection;
